import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import DownloadSection from "@/pages/home/components/DownloadSection";
import Features from "@/pages/home/components/Features";
import VersionCompare from "@/pages/home/components/VersionCompare";
import SystemRequirements from "@/pages/home/components/SystemRequirements";
import InstallSteps from "@/pages/home/components/InstallSteps";
import Changelog from "@/pages/home/components/Changelog";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <DownloadSection />
        <Features />
        <VersionCompare />
        <SystemRequirements />
        <InstallSteps />
        <Changelog />
        <Faq />
        <About />
      </main>
      <Footer />
    </div>
  );
}